<template>
  <el-dialog width="576px" :visible="visible">
    <template #title>
      <div class="title">批量导入处方药</div>
      <i class="el-icon-circle-close close" @click="$emit('close')" />
    </template>
    <div class="hint">
      请下载
      <a
        class="download"
        :href="
          importFileUrl ||
          'https://static-volc.91jkys.com/attachment/20211208153754110_359eb2e8241742098b380e8dad0f3600.xlsx'
        "
      >
        【导入模版】
      </a>
      ， 完善模版信息后上传
    </div>
    <el-upload class="upload-demo" action="" accept=".xlsx" :http-request="uploadFile" :show-file-list="false">
      <div class="upload-file">
        <el-icon class="el-icon-upload" />
        <span class="text">点击导入药品信息文件</span>
      </div>
    </el-upload>
    <div class="repeat-rule">
      <span>重复数据处理规则：</span>
      <el-radio-group v-model="repeatRule">
        <el-radio :label="1">拦截重复数据</el-radio>
        <el-radio :label="2">覆盖重复数据</el-radio>
      </el-radio-group>
    </div>
  </el-dialog>
</template>

<script>
import Fetch from '@/api';
import { mapState } from 'vuex';

export default {
  name: 'uploadExcel',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('drugsManagement', ['importFileUrl'])
  },
  data() {
    return {
      repeatRule: 1
    };
  },
  methods: {
    uploadFile(e) {
      Telescope.trackEvent({
        trackId: 'zywzpc-click-drugsManagement-batchImportDrug-repeatData',
        custom: {
          type: this.repeatRule,
          typeName: ['', '拦截重复数据', '覆盖重复数据'][this.repeatRule]
        }
      });
      const file = e.file;
      const fd = new FormData();
      fd.append('file', file);
      fd.append('importType', this.repeatRule);
      Fetch.importDrugByExcel(fd).then(() => {
        this.$confirm('导入结果正在生成中，请前往下载中心查看', '提示', {
          confirmButtonText: '前往下载中心下载',
          cancelButtonText: '知道了',
          customClass: 'confirm',
          distinguishCancelAndClose: true,
          center: true
        })
          .then(() => this.$router.push('/download'))
          .catch(() => {
            this.$emit('refresh');
          });
      });
      this.$emit('close');
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  position: relative;
  padding: 36px 0 23px 0;

  .close {
    position: absolute;
    top: 12px;
    right: 12px;
    font-size: 14px;
  }
}

/deep/.el-dialog__body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 0 32px 0;
}

.title {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.hint {
  margin-bottom: 24px;
  font-size: 14px;
  color: #262626;

  .download {
    color: #1e8dff;
  }
}

.upload-file {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 378px;
  height: 96px;
  font-size: 14px;
  color: #bdbdbd;
  border: 1px dashed #e6e6e6;
}
.repeat-rule {
  margin-top: 24px;
  > span {
    margin-right: 10px;
  }
}
</style>
